import { EDITABLE_COLUMN_KEYS } from "./editableColumns.js";
export const SECTION_TYPES = {
    CASES: "CASES",
    CLINICAL_CONDITIONS: "CLINICAL_CONDITIONS",
    CASE_FUNDS: "CASE_FUNDS",
};
export const SECTION_TYPE_CONFIG = {
    CASES: {
        label: "Cases",
        allowCustomFields: true,
        allowedColumns: [
            EDITABLE_COLUMN_KEYS.CASE_ID,
            EDITABLE_COLUMN_KEYS.CASE_CLAIM_NUMBER,
            EDITABLE_COLUMN_KEYS.CASE_TITLE,
            EDITABLE_COLUMN_KEYS.CASE_DESCRIPTION,
            EDITABLE_COLUMN_KEYS.CASE_STATUS,
            EDITABLE_COLUMN_KEYS.CASE_REFERRAL_DATE,
            EDITABLE_COLUMN_KEYS.CASE_OCCUPATION_STATUS,
            EDITABLE_COLUMN_KEYS.CASE_CATEGORY,
            EDITABLE_COLUMN_KEYS.CASE_SUB_CATEGORY,
            EDITABLE_COLUMN_KEYS.CASE_FUNDING_AMOUNT,
            EDITABLE_COLUMN_KEYS.CASE_OUTCOME
        ],
    },
    CLINICAL_CONDITIONS: {
        label: "Clinical Conditions",
        allowCustomFields: false,
        allowedColumns: [
            EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_NAME,
            EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_TYPE,
            EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_DESCRIPTION,
            EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_CAUSE,
            EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_ONSET_AT,
            EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_REPORTED_AT,
            EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_IS_WORK_RELATED,
            EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_SEVERITY,
            EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_STATUS,
            EDITABLE_COLUMN_KEYS.CLINICAL_CONDITION_NOTES,
        ],
    },
    CASE_FUNDS: {
        label: "Case Funds",
        allowCustomFields: false,
        allowedColumns: [
            EDITABLE_COLUMN_KEYS.FUNDING_NAME,
            EDITABLE_COLUMN_KEYS.FUNDING_CODE,
            EDITABLE_COLUMN_KEYS.FUNDING_TYPE,
            EDITABLE_COLUMN_KEYS.FUNDING_DESCRIPTION,
            EDITABLE_COLUMN_KEYS.FUNDING_STARTS_AT,
            EDITABLE_COLUMN_KEYS.FUNDING_ENDS_AT,
            EDITABLE_COLUMN_KEYS.FUNDING_STATUS,
            EDITABLE_COLUMN_KEYS.FUNDING_CURRENCY,
            EDITABLE_COLUMN_KEYS.FUNDING_AMOUNT,
        ],
    },
};
export const canSectionUseCustomFields = (sectionType) => SECTION_TYPE_CONFIG[sectionType]?.allowCustomFields ?? false;
//# sourceMappingURL=sectionType.js.map